import {
  DkimStatus,
  MailFromDomainStatus,
  teamEmailAddressSchema,
} from "@redotech/redo-model/email/domain-verification";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const getCustomDomain = {
  name: "getCustomDomain" as const,
  input: z.object({}),
  output: z.object({
    enabled: z.boolean(),
    domain: z.string().nullish(),
    mailFromDomain: z.string().nullish(),
    mailFromDomainStatus: createEnum(MailFromDomainStatus).nullish(),
    addresses: z.array(teamEmailAddressSchema).nullish(),
    defaultFromAddressId: z.string().nullish(),
    defaultReplyToAddressId: z.string().nullish(),
    dkimStatus: createEnum(DkimStatus).nullish(),
    warmingEnabled: z.boolean().nullish(),
  }),
};
